/*
 * Author: Roger
 * File Created: Thursday, 24-09-19 01:13 pm
 * Last Modified: Thursday, 25-03-13 02:18 pm, by Ben Zhao
 */

import { get } from '@web/http';

import type { TransType } from '@/@types/asset';
import type { Asset, Network, UserDepositAddress } from '@/@types/crypto';

export const getEnableAssets = async (_params: { type: TransType }) => {
  return get<Asset[]>(`/gateway/crypto/public/v1/network-coin/assets`, _params);
};

export const getEnableNetworks = async (_params: {
  type: TransType;
  asset: string;
}) => {
  return get<Network[]>(
    `/gateway/crypto/public/v1/network-coin/networks`,
    _params,
  );
};

export const getUserDepositAddress = async (_params: {
  coin: string;
  network: string;
}) => {
  return get<UserDepositAddress>(
    `/gateway/crypto/private/v1/deposit/address`,
    _params,
  );
};
